import _ from 'lodash';

const getExtensionValueDateTime = (resource, fhirUrl) => {
	// Need to add dateTime formatting here
	return _.find(resource.extension, elem => elem.url === fhirUrl)?.valueDateTime || '';
};

export default getExtensionValueDateTime;
